export const medals = [
  {
    Medal: "Silver",
    Games: "1960 Rome",
    Sport: "Athletics",
    Event: "Men's decathlon",
    Gender: "Men",
    n: 1,
    Year: 1960,
    id: 1,
  },
  {
    Medal: "Bronze",
    Games: "1968 Mexico City",
    Sport: "Athletics",
    Event: "Women's 80 metre hurdles",
    Gender: "Women",
    n: 1,
    Year: 1968,
    id: 2,
  },
  {
    Medal: "Bronze",
    Games: "1984 Los Angeles",
    Sport: "Weightlifting",
    Event: "Men's 60 kg",
    Gender: "Men",
    n: 1,
    Year: 1984,
    id: 3,
  },
  {
    Medal: "Silver",
    Games: "1992 Barcelona",
    Sport: "Baseball",
    Event: "Men's competition",
    Gender: "Men",
    n: 1,
    Year: 1992,
    id: 4,
  },
  {
    Medal: "Silver",
    Games: "1996 Atlanta",
    Sport: "Table tennis",
    Event: "Women's singles",
    Gender: "Women",
    n: 1,
    Year: 1996,
    id: 5,
  },
  {
    Medal: "Silver",
    Games: "2000 Sydney",
    Sport: "Weightlifting",
    Event: "Women's 53 kg",
    Gender: "Women",
    n: 1,
    Year: 2000,
    id: 6,
  },
  {
    Medal: "Bronze",
    Games: "2000 Sydney",
    Sport: "Table tennis",
    Event: "Women's singles",
    Gender: "Women",
    n: 1,
    Year: 2000,
    id: 7,
  },
  {
    Medal: "Bronze",
    Games: "2000 Sydney",
    Sport: "Taekwondo",
    Event: "Women's 49 kg",
    Gender: "Women",
    n: 1,
    Year: 2000,
    id: 8,
  },
  {
    Medal: "Bronze",
    Games: "2000 Sydney",
    Sport: "Taekwondo",
    Event: "Men's 58 kg",
    Gender: "Men",
    n: 1,
    Year: 2000,
    id: 9,
  },
  {
    Medal: "Bronze",
    Games: "2000 Sydney",
    Sport: "Weightlifting",
    Event: "Women's 75 kg",
    Gender: "Women",
    n: 1,
    Year: 2000,
    id: 10,
  },
  {
    Medal: "Gold",
    Games: "2004 Athens",
    Sport: "Taekwondo",
    Event: "Women's flyweight",
    Gender: "Women",
    n: 1,
    Year: 2004,
    id: 11,
  },
  {
    Medal: "Gold",
    Games: "2004 Athens",
    Sport: "Taekwondo",
    Event: "Men's flyweight",
    Gender: "Men",
    n: 1,
    Year: 2004,
    id: 12,
  },
  {
    Medal: "Silver",
    Games: "2004 Athens",
    Sport: "Archery",
    Event: "Men's team",
    Gender: "Men",
    n: 1,
    Year: 2004,
    id: 13,
  },
  {
    Medal: "Silver",
    Games: "2004 Athens",
    Sport: "Taekwondo",
    Event: "Men's lightweight",
    Gender: "Men",
    n: 1,
    Year: 2004,
    id: 14,
  },
  {
    Medal: "Bronze",
    Games: "2004 Athens",
    Sport: "Archery",
    Event: "Women's team",
    Gender: "Women",
    n: 1,
    Year: 2004,
    id: 15,
  },
  {
    Medal: "Gold",
    Games: "2008 Beijing",
    Sport: "Weightlifting",
    Event: "Women's 48 kg",
    Gender: "Women",
    n: 1,
    Year: 2008,
    id: 16,
  },
  {
    Medal: "Silver",
    Games: "2008 Beijing",
    Sport: "Weightlifting",
    Event: "Women's 63 kg",
    Gender: "Women",
    n: 1,
    Year: 2008,
    id: 17,
  },
  {
    Medal: "Bronze",
    Games: "2008 Beijing",
    Sport: "Taekwondo",
    Event: "Men's 58 kg",
    Gender: "Men",
    n: 1,
    Year: 2008,
    id: 18,
  },
  {
    Medal: "Bronze",
    Games: "2008 Beijing",
    Sport: "Taekwondo",
    Event: "Men's 68 kg",
    Gender: "Men",
    n: 1,
    Year: 2008,
    id: 19,
  },
  {
    Medal: "Gold",
    Games: "2012 London",
    Sport: "Weightlifting",
    Event: "Women's 53 kg",
    Gender: "Women",
    n: 1,
    Year: 2012,
    id: 20,
  },
  {
    Medal: "Bronze",
    Games: "2012 London",
    Sport: "Taekwondo",
    Event: "Women's 57 kg",
    Gender: "Women",
    n: 1,
    Year: 2012,
    id: 21,
  },
  {
    Medal: "Gold",
    Games: "2016 Rio de Janeiro",
    Sport: "Weightlifting",
    Event: "Women's 53 kg",
    Gender: "Women",
    n: 1,
    Year: 2016,
    id: 22,
  },
  {
    Medal: "Bronze",
    Games: "2016 Rio de Janeiro",
    Sport: "Archery",
    Event: "Women's team",
    Gender: "Women",
    n: 1,
    Year: 2016,
    id: 23,
  },
  {
    Medal: "Bronze",
    Games: "2016 Rio de Janeiro",
    Sport: "Weightlifting",
    Event: "Women's 58 kg",
    Gender: "Women",
    n: 1,
    Year: 2016,
    id: 24,
  },
  {
    Medal: "Gold",
    Games: "2020 Tokyo",
    Sport: "Weightlifting",
    Event: "Women's 59 kg",
    Gender: "Women",
    n: 1,
    Year: 2020,
    id: 25,
  },
  {
    Medal: "Gold",
    Games: "2020 Tokyo",
    Sport: "Badminton",
    Event: "Men's doubles",
    Gender: "Men",
    n: 1,
    Year: 2020,
    id: 26,
  },
  {
    Medal: "Silver",
    Games: "2020 Tokyo",
    Sport: "Judo",
    Event: "Men's 60 kg",
    Gender: "Men",
    n: 1,
    Year: 2020,
    id: 27,
  },
  {
    Medal: "Silver",
    Games: "2020 Tokyo",
    Sport: "Archery",
    Event: "Men's team",
    Gender: "Men",
    n: 1,
    Year: 2020,
    id: 28,
  },
  {
    Medal: "Silver",
    Games: "2020 Tokyo",
    Sport: "Gymnastics",
    Event: "Men's pommel horse",
    Gender: "Men",
    n: 1,
    Year: 2020,
    id: 29,
  },
  {
    Medal: "Silver",
    Games: "2020 Tokyo",
    Sport: "Badminton",
    Event: "Women's singles",
    Gender: "Women",
    n: 1,
    Year: 2020,
    id: 30,
  },
  {
    Medal: "Bronze",
    Games: "2020 Tokyo",
    Sport: "Taekwondo",
    Event: "Women's 57 kg",
    Gender: "Women",
    n: 1,
    Year: 2020,
    id: 31,
  },
  {
    Medal: "Bronze",
    Games: "2020 Tokyo",
    Sport: "Table tennis",
    Event: "Mixed doubles",
    Gender: "Mixed",
    n: 1,
    Year: 2020,
    id: 32,
  },
  {
    Medal: "Bronze",
    Games: "2020 Tokyo",
    Sport: "Weightlifting",
    Event: "Women's 64 kg",
    Gender: "Women",
    n: 1,
    Year: 2020,
    id: 33,
  },
  {
    Medal: "Bronze",
    Games: "2020 Tokyo",
    Sport: "Golf",
    Event: "Men's individual",
    Gender: "Men",
    n: 1,
    Year: 2020,
    id: 34,
  },
  {
    Medal: "Bronze",
    Games: "2020 Tokyo",
    Sport: "Boxing",
    Event: "Women's flyweight",
    Gender: "Women",
    n: 1,
    Year: 2020,
    id: 35,
  },
  {
    Medal: "Bronze",
    Games: "2020 Tokyo",
    Sport: "Karate",
    Event: "Women's 55 kg",
    Gender: "Women",
    n: 1,
    Year: 2020,
    id: 36,
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Gymnastics",
    Event: "Men's Horizontal Bar",
    Gender: "Men",
    n: 1,
    Year: 2024,
    id: 37,
  },
  {
    Medal: "Gold",
    Games: "2024 Paris",
    Sport: "Badminton",
    Event: "Men's Doubles",
    Gender: "Men",
    n: 1,
    Year: 2024,
    id: 38,
  },
  {
    Medal: "Gold",
    Games: "2024 Paris",
    Sport: "Boxing",
    Event: "Women's 57kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 39,
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Boxing",
    Event: "Women's 60kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 40,
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Boxing",
    Event: "Women's 66kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 41,
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Shooting",
    Event: "Skeet Men",
    Gender: "Men",
    n: 1,
    Year: 2024,
    id: 42,
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Weightlifting",
    Event: "Women's 59kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 43,
  },
];
